import styled from "styled-components"

import Icon from "@irati/ui/src/Icon"
import {spacingCss, SpacingProps} from "@irati/ui/src/global/css"

interface MetricCardProps extends SpacingProps {
  isOpen: boolean
}

export const MetricCard = styled.div<MetricCardProps>`
  background-color: ${({isOpen, theme}) => `${isOpen ? theme.colors.secondary2_50 : theme.colors.greys.white}`};
  ${spacingCss}
`

export const CircledNumber = styled.span`
  color: ${({theme}) => theme.colors.utility.ink};
  width: 2em;
  height: 2em;
  border: 1px solid ${({theme}) => theme.colors.utility.ink};
  text-align: center;
  border-radius: 50%;
  line-height: 2em;
  box-sizing: content-box;
  display: inline-block;
`

export const CircledWrapper = styled.div`
  margin-right: ${({theme}) => theme.spacing.one};
`

export const TickWrapper = styled.div`
  background-color: ${({theme}) => theme.colors.primary2};
  width: 2em;
  height: 2em;
  border: 1px solid ${({theme}) => theme.colors.utility.ink};
  text-align: center;
  border-radius: 50%;
  line-height: 2em;
  box-sizing: content-box;
  display: inline-block;
`

export const IconWrapper = styled.div`
  cursor: pointer;
  margin-top: 6px;
`
export const FullWidth = styled.div`
  width: 100%;
`

export const StyledIcon = styled(Icon)`
  position: relative;
  top: 3px;
  left: 1px;
`
